export function generateRequestId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }
  // Fallback for old browsers — not cryptographically unique but good enough for tracing.
  return `req-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}
